import { getMatchingCardsSequence } from 'State/Card/CardReducer';
import { IGameState } from 'State/Game/IGameState';
import { Persona } from './Persona';

abstract class TipPlayer extends Persona {
    protected selectCardToPlay(state: IGameState, _matches: string[]): [IGameState, string] {
        state = getMatchingCardsSequence(state);
        return [state, state.levelState.cardMatchSequence[state.levelState.cardMatchSequenceIndex].card];
    }
}

export class TipPlayerNoCoins extends TipPlayer {
    enabled = false;
    readonly id = 'tipNoCoins';
    readonly playThrough = false;
}

export class TipPlayerPlaythrough extends TipPlayer {
    enabled = false;
    readonly id = 'tipPlaythrough';
    readonly playThrough = true;
}